import { Component } from '@angular/core';

@Component({
    selector: 'mobilize-error',
    imports: [],
    templateUrl: './error.component.html',
    styleUrl: './error.component.scss'
})
export class ErrorComponent {

}
